import type { VisibilityRules } from "./types";

export function isFieldVisible(
  rules: VisibilityRules | Record<string, unknown> | null | undefined,
  valuesByKey: Record<string, string>
): boolean {
  const r = rules as VisibilityRules | null | undefined;
  if (!r || !r.conditions || r.conditions.length === 0) return true;
  const logic = r.logic ?? "AND";

  const results = r.conditions.map((cond) => {
    const fieldValue = valuesByKey[cond.field_key] ?? "";
    const isEmpty = !fieldValue;

    // Operadores que só olham se o campo está vazio — ignoram cond.value.
    if (cond.operator === "is_empty") return isEmpty;
    if (cond.operator === "is_not_empty") return !isEmpty;

    // Demais operadores: campo vazio nunca satisfaz a condição.
    if (isEmpty) return false;

    const condArray = Array.isArray(cond.value)
      ? cond.value.map(String)
      : typeof cond.value === "string"
      ? cond.value.split(",").map((v) => v.trim()).filter(Boolean)
      : [];

    switch (cond.operator) {
      case "equals":
        return condArray.length ? condArray.includes(fieldValue) : fieldValue === String(cond.value);
      case "not_equals":
        return condArray.length ? !condArray.includes(fieldValue) : fieldValue !== String(cond.value);
      case "contains":
        return fieldValue.toLowerCase().includes(String(cond.value).toLowerCase());
      case "in":
        return condArray.includes(fieldValue);
      case "not_in":
        return !condArray.includes(fieldValue);
      default:
        return false;
    }
  });

  return logic === "OR" ? results.some(Boolean) : results.every(Boolean);
}
